import { render, staticRenderFns } from "./NotesListView.vue?vue&type=template&id=4f9a5969&scoped=true"
import script from "./NotesListView.vue?vue&type=script&lang=js"
export * from "./NotesListView.vue?vue&type=script&lang=js"
import style0 from "./NotesListView.vue?vue&type=style&index=0&id=4f9a5969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a5969",
  null
  
)

export default component.exports